document.addEventListener("DOMContentLoaded", () => {
  const main_carousel = new Flickity(".product-carousel--desktop", {
    pageDots: false,
    prevNextButtons: false,
  });

  const mobile_carousel = new Flickity( ".product-carousel--mobile", {
    prevNextButtons: false,
  });

  const hideOneDot = () => {
    const carousel = document.querySelector('.product-carousel--mobile');
    const cells = carousel.querySelectorAll('.product-carousel--image');
    const hasMultipleCells = cells && cells.length > 1;
    
    if (!hasMultipleCells) {
      document.querySelector('.flickity-page-dots').style.display = 'none';
    } 
  }
  
  hideOneDot();

  const thumbnails = document.querySelectorAll(".product-carousel__thumbnail");
  thumbnails[0].classList.add("is-active");

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("mouseover", () => {
      thumbnails.forEach((element) => {
        element.classList.remove("is-active");
      });
      thumbnail.classList.add("is-active");
      main_carousel.select(index);
    });
  });
});
